import { render, staticRenderFns } from "./batch-set-attention-modal.vue?vue&type=template&id=895f94e0"
import script from "./batch-set-attention-modal.vue?vue&type=script&lang=js"
export * from "./batch-set-attention-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports